<template>
  <ValidationObserver ref="formvalid" class="w-100">
    <form novalidate @submit.prevent="save">
      <div class="row-group w-100 pl-4 pt-3">
        <div class="col-12">
          <SectionTitle
            :has-line="true"
            content="Detalles sobre el Servicio a Solicitar"
          />
        </div>
        <div class="row-group m-0 pr-4 pl-4 ml-2 pt-0 w-100 ">
          <div v-if="hasServiceDetails">
            <div class="row w-100 font-weight-regular">
              <div class="col-lg-6 mb-2">
                <CustomDatePicker
                  v-model="model.ThrpyRecommendedEvaluationDate"
                  label="Fecha de Evaluación que recomienda intervención:"
                  :max-date="new Date()"
                />
              </div>
              <div class="col-lg-6 ml-n2">
                <ValidationProvider
                  v-slot="{ errors }"
                  class="w-100"
                  rules="required"
                >
                  <CustomRadioGroup
                    v-model="model.ThrpyIsCompensatory"
                    :label="'¿Servicio de Visitas Compensadas?'"
                    :name="'asd1'"
                    :options="radioButtonsOptionsRefCompen"
                    :error="errors[0]"
                    custom-error-msg="Favor de contestar si son visitas compensadas."
                    :is-inline="true"
                    :is-disabled="true"
                    class="ml-n2"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div
              class="row-group m-0 pr-4 pt-0 w-100 pt-3 ml-n3 adjust-height mb-3"
            >
              <div class="row w-100 font-weight-regular">
                <div class="col-lg-6">
                  <CustomRadioGroup
                    v-model="ThrpySpReferralCompleted"
                    :label="
                      '¿Se completó el referido a la intervención recomendada?'
                    "
                    :name="'asd'"
                    :options="radioButtonsOptions"
                    :is-disabled="true"
                    :is-inline="true"
                  />
                </div>
                <div v-if="model.ThrpyIsCompensatory == '1'" class="col-lg-6">
                  <ValidationProvider
                    v-slot="{ errors }"
                    class="w-100"
                    name="wasInvited"
                    rules="required"
                  >
                    <CustomInput
                      v-model="model.ThrpyCompensatoryMaxVisitCount"
                      label="Favor de indicar la cantidad de visitas compensadas:"
                      type="number"
                      :error="errors[0]"
                      custom-error-msg="Favor de indicar la cantidad de visitas compensadas."
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
          <div class="row-group m-0 pr-4 ml-n3 pt-0 w-100 pt-3">
            <div class="col-lg-6">
              <ValidationProvider
                v-slot="{ errors }"
                class="w-100"
                name="wasInvited"
                rules="required"
              >
                <CustomDatePicker
                  v-model="model.ReferralDate"
                  :max-date="new Date()"
                  :disabled="isReadOnly(model.ReferralDate)"
                  label="Si conoce, indique la fecha del referido"
                  :error="errors[0]"
                  custom-error-msg="Favor de entrar la fecha de referido."
                />
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="col-12 pt-3">
          <SectionTitle
            :has-line="true"
            content="¿Quién Solicita el Remedio?"
          />
        </div>
        <div class="row-group w-100 pl-4 ml-2">
          <div class="row w-100 font-weight-regular">
            <div class="col-lg-4 mb-2">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomInput
                  v-model="model.applicantName"
                  label="Nombre:"
                  type="text"
                  required
                  :error="errors[0]"
                  custom-error-msg="Favor de entrar un nombre"
                />
              </ValidationProvider>
            </div>
            <div class="col-lg-4 mb-2">
              <CustomInput
                v-model="model.applicantResidentialPhoneNumber"
                label="Teléfono Residencial:"
                :mask-type="'Phone'"
                placeholder="(__) __-____"
              />
            </div>
            <div class="col-lg-4 mb-2">
              <CustomInput
                v-model="model.applicantWorkPhoneNumber"
                label="Teléfono Trabajo:"
                :mask-type="'Phone'"
                placeholder="(__) __-____"
              />
            </div>
          </div>
          <div class="row w-100 font-weight-regular">
            <div class="col-lg-4 mb-2">
              <CustomDropDown
                id="cboSolicitante"
                v-model="model.selectedApplicant"
                fieldkey="id"
                label="Solicitante:"
                fieldname="name"
                :options="RemedyApplicantInformation.applicants"
                :clearable="false"
                :disabled="true"
              />
            </div>
            <div class="col-lg-4">
              <CustomInput
                v-model="model.applicantCellPhoneNumber"
                label="Teléfono Celular:"
                :mask-type="'Phone'"
                placeholder="(__) __-____"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row-group w-100 pl-4">
        <div class="col-12">
          <div class="row w-100 mt-4">
            <div class="col-12">
              <SectionTitle
                :has-line="true"
                content="Información del Encargado"
              />
            </div>
            <div class="row w-100 pl-3 ml-1">
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="nombre"
                  rules="required"
                >
                  <CustomInput
                    v-model="model.personInChargeName"
                    label="Nombre: "
                    rules="required"
                    :error="errors[0]"
                    custom-error-msg="Favor de entrar el nombre."
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider v-slot="{ errors }" name="teléfono">
                  <CustomInput
                    v-model="model.contactResidentialPhoneNumber"
                    label="Teléfono Residencial: "
                    mask-type="Phone"
                    :masked="false"
                    placeholder="(__) __-____"
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider v-slot="{ errors }" name="teléfono">
                  <CustomInput
                    v-model="model.contactWorkPhoneNumber"
                    label="Teléfono Trabajo: "
                    mask-type="Phone"
                    :masked="false"
                    placeholder="(__) __-____"
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="email"
                  rules="required|email"
                  :custom-messages="{
                    required: 'Favor de ingresar un correo electrónico.',
                    email: 'Favor de entrar un correo electrónico válido.',
                  }"
                >
                  <CustomInput
                    v-model="model.contactEmail"
                    label="Correo Electrónico: "
                    :error="errors[0]"
                    type="email"
                    class="email"
                    :custom-error-msg="errors[0]"
                    left-icon
                    icon="fa fa-at orange-icon"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="teléfono"
                  rules="required"
                >
                  <CustomInput
                    v-model="model.contactCellPhoneNumber"
                    label="Teléfono Celular: "
                    mask-type="Phone"
                    :masked="false"
                    placeholder="(__) __-____"
                    :error="errors[0]"
                    custom-error-msg="Favor de registrar un teléfono para continuar"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="row w-100 mt-4">
            <div class="col-12">
              <SectionTitle
                :has-line="true"
                content="Dirección Postal a Recibir Información"
              />
            </div>
            <div class="row w-100 pl-3 ml-1 ">
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="linea 1"
                  rules="required"
                >
                  <CustomInput
                    id="txtLine1"
                    v-model="model.postalAddressLine1"
                    label="Línea 1:"
                    placeholder="Línea"
                    rules="required"
                    custom-error-msg="Favor de entrar la línea 1 de la dirección postal."
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomDropDown
                    id="cboDireccionPostalMunicipio"
                    v-model="model.selectedPostalAddresMunicipality"
                    label="Municipio:"
                    fieldkey="id"
                    fieldname="name"
                    :options="municipality"
                    :clearable="false"
                    :error="errors[0]"
                    placeholder="Seleccione"
                    custom-error-msg="Favor de entrar el municipio de la dirección postal."
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-sm-12 mt-3">
                <CustomInput
                  id="txtPais"
                  label="País"
                  placeholder="PR"
                  :disabled="true"
                />
              </div>
            </div>
            <div class="row w-100 pl-3 ml-1 pt-2">
              <div class="col-md-4 col-sm-12 mt-3">
                <CustomInput
                  id="txtLine2"
                  v-model="model.postalAddressLine2"
                  label="Línea 2:"
                  placeholder="Línea 2"
                />
              </div>
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="zipcode"
                  rules="required"
                >
                  <CustomInput
                    id="zipcode"
                    v-model="model.postalAddressZipCode"
                    label="Zipcode:"
                    mask-type="Zipcode"
                    placeholder="#####"
                    required
                    :custom-error-msg="
                      'Favor de entrar el código postal de la dirección postal.'
                    "
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <!--  Servicio Educativo del estudiante -->
          <div class="row w-100 mt-4">
            <div class="col-12">
              <SectionTitle
                :has-line="true"
                content="Servicio Educativo del Estudiante"
              />
            </div>
            <div class="row w-100 pl-3 ml-1">
              <div class="col-md-4 col-sm-12 mb-2">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomDropDown
                    v-model="model.selectedPlace"
                    required
                    :options="place"
                    fieldkey="id"
                    fieldname="name"
                    :clearable="false"
                    label="Lugar:"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg="resources['17002']"
                    @input="onChangePlace"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-sm-12">
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="`${showMunicipality ? 'required' : ''}`"
                >
                  <CustomDropDown
                    v-if="showMunicipality"
                    id="cboMunicipio"
                    v-model="model.selectedMunicipality"
                    label="Municipio:"
                    fieldkey="id"
                    fieldname="name"
                    :options="municipality"
                    :clearable="false"
                    :error="errors[0]"
                    placeholder="Seleccione"
                    :custom-error-msg="resources['17002']"
                    @input="onMunicipalityChange($event)"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row w-100 pl-3 ml-1 pt-2">
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomDropDown
                    v-if="showRegion"
                    id="cboRegion"
                    v-model="model.selectedRegion"
                    label="Región:"
                    :options="regions"
                    placeholder="Seleccione"
                    :fieldkey="'id'"
                    :fieldname="'name'"
                    :disabled="isDisabled"
                    :clearable="false"
                    :error="errors[0]"
                    custom-error-msg="Favor de seleccionar la Región."
                    @input="onRegionChange($event)"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-sm-12 mb-3 mt-3 pr-3 pl-3">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomDropDown
                    v-if="showDistrict"
                    v-model="model.selectedDistrict"
                    :options="district"
                    placeholder="Seleccione"
                    required
                    :fieldkey="'id'"
                    :fieldname="'name'"
                    label="Distrito:"
                    :disabled="isDisabled"
                    :clearable="false"
                    :error="errors[0]"
                    custom-error-msg="Favor de seleccionar la Distrito."
                    @input="onDistrictChange($event)"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-sm-12 mt-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Escuela"
                  rules="required"
                >
                  <custom-drop-down
                    v-if="showSchool"
                    v-model="model.selectedSchool"
                    :options="schools"
                    placeholder="Seleccione"
                    required
                    :fieldkey="'id'"
                    :fieldname="'name'"
                    label="Escuela:"
                    :disabled="
                      model.selectedSchool && model.selectedSchool.disabled
                    "
                    :error="errors[0]"
                    :clearable="false"
                    custom-error-msg="Favor de seleccionar la Escuela."
                  />
                </ValidationProvider>
                <div class="pd">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :rules="`${showCareCenterName ? 'required' : ''}`"
                  >
                    <CustomInput
                      v-if="showCareCenterName"
                      v-model="model.careCenterName"
                      label="Nombre:"
                      type="text"
                      :error="errors[0]"
                      custom-error-msg="Favor de entrar el nombre."
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
          <!-- información adicional -->
          <div class="row w-100 mt-4">
            <div class="col-12">
              <SectionTitle
                :has-line="true"
                content="Información Adicional a ser Considerada"
              />
            </div>
            <div class="row w-100 pl-3 ml-1">
              <ValidationProvider
                v-slot="{ errors }"
                slim
                rules="required"
                name="Comments"
              >
                <custom-text-area
                  v-model="model.AdditionalInformation"
                  :label="'Comentario'"
                  required
                  :placeholder="''"
                  :maxlength="2000"
                  :error="`${errors[0] ? 'error' : ''}`"
                  :custom-error-msg="errorMsgs['SelectComment']"
                  class="w-100 pl-2"
                  :show-char-count="true"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomTextArea from '@/components/common/CustomTextArea';
import CustomRadioGroup from '@/components/common/CustomRadio';
import CustomInput from '@/components/common/CustomInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomDatePicker from '@/components/common/CustomDatePicker';

import resourcesService from '@/services/resources.js';
import mixAlert from '@/mixin/alert.mixin';
import schoolTypes from '@/utils/constants/student/schoolTypes.js';
import schoolCenters from '@/utils/constants/student/schoolCenters.js';
import viewTypes from '@/utils/constants/comment/CodeViewTypes.js';

const initialState = {
  selectedPostalAddresMunicipality: null,
  selectedSchool: null,
  selectedPlace: null,
  selectedDistrict: null,
  selectedRegion: null,
  selectedMunicipality: null,
  personInChargeName: null,
  contactResidentialPhoneNumber: null,
  contactWorkPhoneNumber: null,
  contactCellPhoneNumber: null,
  postalAddressLine1: null,
  postalAddressLine2: null,
  applicantName: null,
  applicantResidentialPhoneNumber: null,
  applicantCellPhoneNumber: null,
  studentSieId: null,
  academicYearId: null,
  contactEmail: null,
  selectedApplicant: null,
  selectedPostalAddressCityId: null,
  postalAddressZipCode: null,
  municipalityId: null,
  locationTypeId: null,
  districtId: null,
  locationSchoolId: null,
  AdditionalInformation: null,
  ApplicantPositionId: null,
  RegionId: null,
  postalAddressCityId: null,
  careCenterName: null,
  ThrpyRecommendedEvaluationDate: null,
  ThrpySpReferralCompleted: '1',
  ThrpyIsCompensatory: null,
  ReferralDate: null,
  ThrpyCompensatoryMaxVisitCount: null,
  applicantWorkPhoneNumber: null,
  showMunicipality: false,
  showRegion: false,
  showSchool: false,
  showDistrict: false,
  showCareCenterName: false,
  isDisabled: false,
  // sie: null,
  parentsData: null,
  currentPostalAddress: null,
  currentInChargeName: null,
  currentYear: {
    id: null,
    description: null,
    year: null,
  },
};

const referralCompletedVal = {
  si: '1',
  no: '2',
};
const referralCompensatedVal = {
  si: '1',
  no: '2',
};
export default {
  name: 'RemedyRequestForm',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    ValidationProvider,
    ValidationObserver,
    CustomTextArea,
    CustomInput,
    CustomDropDown,
    CustomDatePicker,
    CustomRadioGroup,
  },
  data: () => ({
    model: { ...initialState },
    resources: [],
    municipality: [],
    schools: [],
    regions: [],
    place: [],
    type: [],
    region: [],
    district: [],
    showMunicipality: false,
    showRegion: false,
    showSchool: false,
    showDistrict: false,
    showCareCenterName: false,
    isDisabled: false,
    sie: null,
    parentsData: null,
    currentPostalAddress: null,
    currentInChargeName: null,
    ThrpySpReferralCompleted: referralCompletedVal.si,
    ProvisionalRemedyRequest: {
      name: null,
      sie: null,
      disciplineName: null,
      modalityTypeName: null,
      frequecy: null,
      duration: null,
    },
    RemedyApplicantInformation: {
      name: null,
      residentialPhone: null,
      workPhone: null,
      applicants: [],
      selectedApplicant: null,
      cellPhone: null,
    },
    radioButtonsOptions: [
      { label: 'Si', value: referralCompletedVal.si },
      { label: 'No', value: referralCompletedVal.no },
    ],
    ThrpyIsCompensatory: referralCompensatedVal.no,
    radioButtonsOptionsRefCompen: [
      { label: 'Si', value: referralCompensatedVal.si },
      { label: 'No', value: referralCompensatedVal.no },
    ],
    errorMsgs: {
      SelectComment: 'Favor registrar comentario.',
    },
  }),
  computed: {
    hasServiceDetails() {
      return this.info.hasServiceDetails;
    },
  },
  methods: {
    async save() {
      const isValid = await this.$refs.formvalid.validate();
      if (!isValid) {
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada.',
          'error'
        );
        return;
      }

      const modelToSend = { ...this.model };

      if (modelToSend.selectedMunicipality !== null) {
        modelToSend.municipalityId = modelToSend.selectedMunicipality.id;
      } else {
        modelToSend.municipalityId =
          modelToSend.selectedPostalAddresMunicipality.id;
      }

      if (modelToSend.ThrpyCompensatoryMaxVisitCount === null) {
        modelToSend.ThrpyCompensatoryMaxVisitCount = -1;
      } else {
        modelToSend.ThrpyCompensatoryMaxVisitCount = Number.parseInt(
          modelToSend.ThrpyCompensatoryMaxVisitCount
        );
      }

      modelToSend.studentSieId = this.ProvisionalRemedyRequest.sie;
      modelToSend.academicYearId = this.currentYear.id;
      modelToSend.locationTypeId = modelToSend.selectedPlace.id;
      modelToSend.ApplicantPositionId = modelToSend.selectedApplicant.id;
      modelToSend.districtId = modelToSend.selectedDistrict.id;
      modelToSend.locationSchoolId = modelToSend.selectedSchool.id;
      modelToSend.RegionId = modelToSend.selectedRegion.id;
      modelToSend.postalAddressCityId =
        modelToSend.selectedPostalAddresMunicipality.id;

      modelToSend.ThrpySpReferralCompleted = Number.parseInt(
        modelToSend.ThrpySpReferralCompleted
      );
      modelToSend.ThrpyIsCompensatory = Number.parseInt(
        modelToSend.ThrpyIsCompensatory
      );

      modelToSend.ThrpyDisciplineTypeId = this.ProvisionalRemedyRequest.ThrpyDisciplineTypeId;
      modelToSend.ThrpyTherapyDurationId = this.ProvisionalRemedyRequest.ThrpyTherapyDurationId;
      modelToSend.ThrpyFrequencyTypeId = this.ProvisionalRemedyRequest.ThrpyFrequencyTypeId;
      modelToSend.ThrpyModalityTypeId = this.ProvisionalRemedyRequest.ThrpyModalityTypeId;
      modelToSend.ThrpySpReferralCompleted = this.ProvisionalRemedyRequest.ThrpySpReferralCompleted;
      modelToSend.ThrpyAdmissionId = this.ProvisionalRemedyRequest.ThrpyAdmissionId;
      modelToSend.StudentReferralId = this.ProvisionalRemedyRequest.studentReferralId;

      this.performSave(modelToSend);
    },
    async performSave(model) {
      let self = this;
      let url = 'api/studentreferrals/saveprovisionalremedyrequest';

      if (!this.ProvisionalRemedyRequest.IsThrpy) {
        url = 'api/studentevaluation/saveprovisionalremedyrequest';
      }

      self
        .$ApiPost(url, model)
        .then(() => {
          self.ShowToast(
            'Proceso Exitoso.',
            'La solicitud de evaluación fue referida a remedio provisional exitosamente.',
            'success'
          );
          self.$router.go(-1);
        })
        .catch((err) => {
          self.ShowToast('', err.message, 'error');
        });
    },
    async loadProvisionalRemedy() {
      let self = this;
      self
        .$ApiGet('/api/studentevaluation/applicantposition')
        .then((res) => {
          self.RemedyApplicantInformation.applicants = res.data;
          self.model.selectedApplicant =
            self.RemedyApplicantInformation.applicants[
              res.data.findIndex((x) => x.name === 'Funcionario del CSEE')
            ];
        })
        .catch((err) => {
          self.ShowToast('', err.message, 'error');
        });
    },
    loadRegionAndMunicipality() {
      this.$ApiGet(
        `api/schools/types/regions?academicyear=${this.currentYear.id}`
      ).then((response) => {
        this.regions = response.data;
      });

      this.$ApiGet('/api/schools/municipalities').then((res) => {
        this.municipality = res.data;
      });
    },
    loadRegion(municipalityId) {
      let self = this;
      self.$ApiGet(`api/schools/types/regions`).then((response) => {
        this.regions = response.data;
        this.loadDistricts(municipalityId);
      });
    },
    loadRegionAndDistrictByMunicipality(municipalityId) {
      let self = this;

      self
        .$ApiGet(
          `api/schools/types/regions/districts/municipality?MunicipalityId=${municipalityId}&academicyear=${this.currentYear.id}`
        )
        .then((response) => {
          this.model.selectedDistrict = null;
          this.model.selectedRegion = null;
          this.model.selectedRegion = this.regions.find(
            (x) => x.id == response.data.regionId
          );
          this.model.selectedDistrict = this.district.find(
            (x) => x.id == response.data.districtId
          );

          this.loadSchools(
            this.model.selectedPlace.id,
            response.data.districtId,
            municipalityId
          );
        });
    },
    isReadOnly(ReferralDate) {
      if (ReferralDate != null) {
        return true;
      }
    },
    async loadCurrentYear() {
      let self = this;
      await self;
      this.$ApiGet(`api/academicyears/current`).then((response) => {
        this.currentYear = response.data;
        this.loadRegionAndMunicipality();
        this.loadStudentSchool();
      });
    },
    async loadPlaces() {
      let self = this;
      await self
        .$ApiGet(`/api/schools/locationtypes/${viewTypes.Unset}`)
        .then((res) => {
          this.place = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async loadResources() {
      let resourceCodes = [
        '17000',
        '17001',
        '17002',
        '17003',
        '17004',
        '17005',
        '17006',
        '17007',
        '17008',
        '17047',
        '17048',
        '17053',
        '17054',
        '17055',
        '22122',
        'R03200108',
        '22053',
      ];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    loadDistrictsByRegionId(regionId) {
      this.$ApiGet(
        `api/schools/types/regions/districts?regionid=${regionId}&academicyear=${this.currentYear.id}`
      ).then((response) => {
        this.district = response.data;
      });
    },
    loadDistricts(municipalityId) {
      this.$ApiGet(`api/schools/types/regions/districts`).then((response) => {
        this.district = response.data;
        this.loadRegionAndDistrictByMunicipality(municipalityId);
      });
    },
    loadSchools(schoolType, districtId, municipalityId) {
      this.$ApiGet(
        `api/location/schools?SchoolTypes=${schoolType}&districtid=${districtId}&academicyearid=${this.currentYear.id}&municipalityid=${municipalityId}`
      ).then((response) => {
        this.schools = response.data;
        this.model.selectedSchool = null;

        if (this.schools.length == 1) {
          this.model.selectedSchool = this.schools[0];
        }
      });
    },
    onRegionChange(item) {
      this.model.selectedRegion = item;
      this.model.selectedDistrict = null;
      this.model.selectedSchool = null;
      this.schools = [];
      this.loadDistrictsByRegionId(item.id);
    },
    onDistrictChange(item) {
      this.model.selectedDistrict = item;
      this.model.selectedSchool = null;
      this.schools = [];
      this.loadSchools(this.model.selectedPlace.id, item.id, null);
    },
    async onChangePlace({ ...item }) {
      this.model.selectedPlace = item;
      this.model.selectedMunicipality = null;
      this.model.selectedSchool = null;
      this.schools = [];
      this.district = [];

      this.preLoadStudentInfo(item.id);
    },
    onMunicipalityChange({ ...item }) {
      this.model.selectedMunicipality = item;

      this.loadRegion(item.id);
    },
    loadStudentSchool() {
      this.$ApiGet(
        `api/student/getstudentschool/${this.sie}/${this.currentYear.id}`
      ).then((response) => {
        this.currentSchool = response.data;

        if (
          this.currentSchool.schoolId !== schoolCenters.PublicCenter &&
          this.currentSchool.schoolId !== schoolCenters.PrivateCenter &&
          this.currentSchool.schoolId !== -1
        ) {
          //auto seleccionamos escuela pública
          this.model.selectedPlace = this.place.find(
            (x) => x.id == this.currentSchool.schoolType
          );
          this.model.selectedRegion = {
            id: this.currentSchool.regionId,
            name: this.currentSchool.regionName,
          };
          this.model.selectedDistrict = {
            id: this.currentSchool.districtId,
            name: this.currentSchool.districtName,
          };
          this.model.selectedSchool = {
            id: this.currentSchool.schoolId,
            name: this.currentSchool.schoolName,
          };

          this.model.selectedMunicipality = {
            id: this.currentSchool.municipalityId,
            name: this.currentSchool.municipalityName,
          };
          this.showRegion = true;
          this.showSchool = true;
          this.showDistrict = true;

          if (
            this.model.selectedPlace.id === schoolTypes.PrivateSchool ||
            this.model.selectedPlace.id === schoolTypes.HeadStart ||
            this.model.selectedPlace.id === schoolTypes.CareCenter
          ) {
            this.model.selectedSchool.disabled = true;
          }

          this.preLoadStudentInfo();
        }
      });
    },
    preLoadStudentInfo() {
      /* Centro de Cuido, Escuelas Privadas y Head Start */
      if (
        this.model.selectedPlace.id === schoolTypes.PrivateSchool ||
        this.model.selectedPlace.id === schoolTypes.HeadStart ||
        this.model.selectedPlace.id === schoolTypes.CareCenter
      ) {
        this.showMunicipality = true;
        this.showRegion = true;
        this.showSchool = true;
        this.showDistrict = true;
        this.showCareCenterName = true;
        this.isDisabled = true;
      } else if (
        this.model.selectedPlace.id === schoolTypes.PublicSchool ||
        this.model.selectedPlace.id === schoolTypes.Institutions
      ) {
        /*  Escuelas Públicas e Insituciones */

        this.showRegion = true;
        this.showSchool = true;
        this.showDistrict = true;
        this.isDisabled = false;
        this.showMunicipality = false;
        this.showCareCenterName = false;
      } else if (this.model.selectedPlace.id === schoolTypes.Home) {
        this.showMunicipality = true;
        this.showRegion = true;
        this.showSchool = true;
        this.showDistrict = true;
        this.isDisabled = false;
        this.showCareCenterName = false;
      }
    },
    populateExistingData(sie) {
      this.$ApiGet(`api/studentreferrals/addionalrprequestinfo/${sie}`).then(
        (response) => {
          this.model.personInChargeName = response.data.parentName;
          this.model.postalAddressLine1 = response.data.postalAddressLine1;
          this.model.postalAddressLine2 = response.data.postalAddressLine2;
          this.model.postalAddressZipCode = response.data.postalAddressZipCode;

          if (response.data.municipalityId != null) {
            this.model.selectedPostalAddresMunicipality = this.municipality.find(
              (x) => x.id == response.data.municipalityId
            );
          }
        }
      );
    },
  },
  props: {
    info: {
      type: Object,
      default: () => ({
        sie: null,
        thrpyReferralDate: null,
        thrpySpReferralCompleted: false,
        hasServiceDetails: false,
      }),
    },
  },
  async mounted() {
    if (this.info.sie) {
      this.ProvisionalRemedyRequest = this.info;
      this.model.ThrpySpReferralCompleted = this.ProvisionalRemedyRequest.ThrpySpReferralCompleted;
      this.sie = this.ProvisionalRemedyRequest.sie;
      this.model.ReferralDate = this.ProvisionalRemedyRequest.ThrpyReferralDate
        ? new Date(this.ProvisionalRemedyRequest.ThrpyReferralDate)
        : null;
      this.showMunicipality = false;
      this.showRegion = false;
      this.showSchool = false;
      this.showDistrict = false;
      this.model.applicantName =
        this.userProfile.firstname + ' ' + this.userProfile.lastpaternalname;
      this.model.ThrpyIsCompensatory = '2';

      await this.loadCurrentYear();
      await this.loadProvisionalRemedy();
      await this.loadResources();
      await this.loadPlaces();
      await this.populateExistingData(this.info.sie);
    }
  },
};
</script>

<style scoped>
.main-content {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.top-radius {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.bottom-divider {
  border-bottom: 1px solid lightgray;
  border-bottom-width: thin;
}
.radius-5 {
  border-radius: 5px;
}
.fs-16 {
  font-size: 16px;
}
.row.w-100.font-weight-regular {
  font-weight: normal;
}

.pd {
  padding-top: 10px;
}
.service-content {
  border: #f4f6f3 solid 18px;
  border-radius: 5px;
  opacity: 1;
}
.adjust-height {
  height: 69px;
}
.input-group-prepend {
  padding-top: 29px;
  color: #ff7058;
}
.input-group-text {
  color: #ff7058;
}
.email > .input-label {
  margin-left: -36px;
}
</style>
